// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import filteredSearchResults from './filtered-search-results';
import isValidDealer from './is-valid-dealer';
import searchByType from '../../shared/reducers/search-by-type';
import searchFilters from './search-filters';
import searchResults from './search-results';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    facets,
    filteredSearchResults,
    isValidDealer,
    searchByType,
    searchFilters,
    searchResults
});



// WEBPACK FOOTER //
// ./src/pip/pip-search/reducers/index.js